module.exports = __webpack_public_path__ + "static/media/wrong.fbb8ff33.webp";